/**
 * <zh/> 获取图形的所有子元素
 *
 * <en/> Get all the child elements of the shape
 * @param shape <zh/> 图形元素 | <en/> shape
 * @returns <zh/> 子元素数组 | <en/> child elements array
 */
export function getDescendantShapes(shape) {
    const succeeds = [];
    // 遍历所有子元素，并将子元素的子元素加入到数组中
    const traverse = (shape) => {
        if (shape?.children.length) {
            shape.children.forEach((child) => {
                succeeds.push(child);
                traverse(child);
            });
        }
    };
    traverse(shape);
    return succeeds;
}
//# sourceMappingURL=shape.js.map